"use client";

/**
 * MobileMenuAccordion.tsx
 *
 * Sliding menu that expands beneath the navbar on mobile devices.
 */

import React from "react";
import Link from "next/link";

interface LinkItem {
  name: string;
  label?: string;
  href: string;
}

interface MobileMenuAccordionProps {
  isOpen: boolean;
  links: LinkItem[];
  reservationHref: string;
  reservationLabel: string;
  onClose: () => void;
}

const MobileMenuAccordion = ({
  isOpen,
  links,
  reservationHref,
  reservationLabel,
  onClose,
}: MobileMenuAccordionProps) => {
  return (
    <div
      className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out bg-[#1a1a1a] shadow-2xl border-t border-white/10 ${
        isOpen
          ? "max-h-[500px] visible opacity-100"
          : "max-h-0 invisible opacity-0"
      }`}
    >
      <div className="container mx-auto px-6 py-10 flex flex-col items-center space-y-6">
        {/* Navigation list */}
        {links.map((link, index) => (
          <Link
            key={`${link.name}-${index}`}
            href={link.href}
            onClick={onClose}
            className="text-lg font-bold font-inter text-white hover:text-[#c59d5f] transition-colors tracking-wide uppercase flex items-center gap-2 group w-full justify-center"
          >
            {link.label || link.name}
            <span className="text-gray-500 group-hover:text-[#c59d5f] transition-colors text-sm">
              +
            </span>
          </Link>
        ))}

        {/* Reservation CTA button at the end */}
        <Link
          href={reservationHref}
          onClick={onClose}
          className="text-lg font-bold font-inter text-[#c59d5f] transition-colors tracking-wide uppercase flex items-center gap-2"
        >
          {reservationLabel}
        </Link>
      </div>
    </div>
  );
};

export default MobileMenuAccordion;
